var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.6504C9.25374 10.6504 11.1718 10.9693 12.7598 11.6055C13.5532 11.9233 14.2232 12.3046 14.6846 12.7305C15.1416 13.1523 15.3496 13.5737 15.3496 14V15.3496H0.650391V14C0.650391 13.5737 0.858423 13.1523 1.31543 12.7305C1.77684 12.3046 2.44682 11.9233 3.24023 11.6055C4.82819 10.9693 6.74626 10.6504 8 10.6504ZM8 0.650391C9.85101 0.650391 11.3496 2.14899 11.3496 4C11.3496 5.85102 9.85102 7.34961 8 7.34961C6.14898 7.34961 4.65039 5.85102 4.65039 4C4.65039 2.14899 6.14899 0.650391 8 0.650391Z",
    stroke: "#1F1F1F",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.df6e54a8d844e0c397dcf9d0fc55fde9.svg";
export { ForwardRef as ReactComponent };